export default __webpack_public_path__ + "static/2358-d81e78bca49c7cec92cb08972064721b.gif";